import React from 'react'
import InfoIcon from '../../icons/info.svg'
import Composition from './Composition'

class Movie extends React.Component {

  getCompositions () {
    const {composition: {compositions}, cplIds, showModal, sendKDMEmail, downloadKDMs, loadTheatreDetails, user} = this.props
    return compositions.map((composition, idx) =>
      <Composition
        key={idx} composition={composition} showModal={showModal}
        sendKDMEmail={sendKDMEmail} downloadKDMs={downloadKDMs}
        expand={cplIds.includes(composition.id)}
        toggleExpand={() => this.props.toggleExpand(composition.id)}
        loadTheatreDetails={loadTheatreDetails}
        user={user}
      />
    )
  }

  render () {
    const {name, language, releaseYear , id} = this.props.composition
    return (
      <div className="movie qw-m-small qw-pt-x-small qw-pb-xx-small">
        <div style={{display: 'flex', width: '100%'}}>
          <div style={{width: '90%'}}>
          <p className="movie-name qw-font-size-body qw-line-height-body qw-color-text-body qw-bold qw-ml-small">
            {name}
            {
              releaseYear
              ?
              <span>({releaseYear})</span>
              :
              null
            }
            <span className="movie-language qw-font-size-small qw-regular qw-color-text-body" style={{paddingLeft: 10}}>
              {language}
            </span>
          </p>
          </div>
          <div className="movie-name-details-info">
           <InfoIcon className="qw-icon-small" onClick={() => this.props.openMovieModal(id)}/>
          </div>
        </div>

        {this.getCompositions()}
      </div>
    )
  }
}

export default Movie



// WEBPACK FOOTER //
// ./src/app/components/compositions/Movie.js